// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const InternalNetworkAgentStatusSchema = z.enum(['PENDING','ACTIVE','REVOKED','OFFLINE'] as const);

export type InternalNetworkAgentStatusType = `${z.infer<typeof InternalNetworkAgentStatusSchema>}`

export default InternalNetworkAgentStatusSchema;
